<template>
    <div>
        <config-main-title>
            Protocolo de Envio da Recepção
        </config-main-title>

        <guias tipo="envio" :id_usuario="id_usuario" />
    </div>
</template>

<script>
import Guias from '../faturamento/Guias.vue';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';

export default {
    components: { 
        Guias,
        ConfigMainTitle,
    }, 

    props: ['id_usuario', 'status'],
}
</script>